import { Box, Grid, GridItem, Heading, Stack, VStack } from '@chakra-ui/react';
import React from 'react';
import { useSelector } from 'react-redux';
import BoxUpdates from '../components/Dashboard/BoxUpdates';
import Checkins from '../components/Dashboard/Checkins';
import Mentees from '../components/Dashboard/Mentees';
import MyTeam from '../components/Dashboard/MyTeam';
import Notifications from '../components/Dashboard/Notifications';
import Personal from '../components/Dashboard/Personal';
import RemindersDash from '../components/Dashboard/RemindersDash';
import { getCurrentUserInfo } from '../utils/getCurrentUserInfo';

const DashboardPage = () => {
  const { userInfo, isAssumed, assumedUserInfo } = useSelector(
    state => state.user
  );
  const currentUser = getCurrentUserInfo({
    assumedUserInfo,
    isAssumed,
    userInfo,
  });
  const getTemplateAreas = size => {
    if (size === 'lg') {
      if (userInfo.role === 'coach' && !isAssumed) {
        return `"notifications notifications reminders"
                "mentees mentees updates"`;
      }
      if (
        (userInfo.role === 'employer' || userInfo.role === 'manager') &&
        !isAssumed
      ) {
        return `"notifications notifications reminders"
                "checkins checkins updates"`;
      }
      return `"notifications notifications reminders"
              "notifications notifications updates"`;
    }

    if (userInfo.role === 'coach' && !isAssumed) {
      return `"notifications"
        "reminders"
        "mentees"
        "updates"`;
    }
    if (
      (userInfo.role === 'employer' || userInfo.role === 'manager') &&
      !isAssumed
    ) {
      return `"notifications"
        "reminders"
        "checkins"
        "updates"`;
    }
    return `"notifications"
        "reminders"
        "updates"`;
  };
  return (
    <Box
      h={{ base: 'auto', lg: 'calc(100vh - 70px)' }}
      px={{ base: 4, lg: 8 }}
      py={8}
      overflowY={'auto'}
    >
      <Grid
        templateAreas={{
          base: getTemplateAreas('base'),
          lg: getTemplateAreas('lg'),
        }}
        gridTemplateColumns={{ base: '1fr', lg: '1fr 1fr 1fr' }}
        h="full"
        gap={{ base: '4', lg: '2' }}
      >
        <GridItem
          pl="2"
          area={'notifications'}
          minH={{ base: '600px', lg: '350px' }}
        >
          <VStack spacing={{ base: 4, md: 2 }} h={'full'}>
            <Box w={'full'}>
              <Heading>Hi {currentUser.full_name}, welcome back!</Heading>
              <Heading
                as="h6"
                size="xs"
                fontWeight={'normal'}
                mt={'4'}
                color={'lightGray'}
              >
                Here are some important information for you
              </Heading>
            </Box>
            <Personal />
            <Notifications />
          </VStack>
        </GridItem>
        <GridItem pl="2" area={'reminders'} minH={'350px'}>
          <RemindersDash />
        </GridItem>
        {userInfo.role === 'coach' && !isAssumed ? (
          <GridItem
            pl="2"
            area={'mentees'}
            minH={{ base: '600px', lg: '250px' }}
          >
            <Stack
              direction={{ base: 'column-reverse', lg: 'row' }}
              h={'full'}
              w={'full'}
            >
              <Mentees />
              <Checkins />
            </Stack>
          </GridItem>
        ) : null}
        {(userInfo.role === 'employer' || userInfo.role === 'manager') &&
        !isAssumed ? (
          <GridItem
            pl="2"
            area={'checkins'}
            minH={{ base: '600px', lg: '250px' }}
          >
            <Stack
              direction={{ base: 'column-reverse', lg: 'row' }}
              h={'full'}
              w={'full'}
            >
              <MyTeam />
              <Checkins />
            </Stack>
          </GridItem>
        ) : null}
        <GridItem pl="2" area={'updates'} minH={{ base: '600px', lg: '250px' }}>
          <BoxUpdates />
        </GridItem>
      </Grid>
    </Box>
  );
};

export default DashboardPage;
